import { render, staticRenderFns } from "./SystemRequirements.vue?vue&type=template&id=216e01bd&"
import script from "./SystemRequirements.vue?vue&type=script&lang=ts&"
export * from "./SystemRequirements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports